<div *ngIf="!loginDisplay">
  <mat-spinner class="center" *ngIf="loading"></mat-spinner>
  <div *ngIf="!loading">
    <div class="row">
        <div class="column" *ngIf="schoolLoc">
          <h2>Attendance Percentage</h2>
          <app-Gauge [mainValue]="schoolLoc" [schoolTarget]="schoolTarget"></app-Gauge>
        </div>
        <div class="column" *ngIf="res">
          <h2>Grading Periods</h2>
          <app-LineGraph [dataSo]="dataSource3"></app-LineGraph>
        </div>
    </div>

    <div *ngIf="res">
      <h2>Weekly Trend</h2>
      <app-LineGraph [dataSo]="dataSource4" [sizeG]="true" ></app-LineGraph>
    </div>
    <br>
    <div>
      <h2>Attendance Report</h2>
      <app-Heatmap [dataH]="DailyChartCurrent"></app-Heatmap>
    </div>
    <br>
  </div>
</div>
<!-- <p>{{res | json }}</p> -->
